export default {
  numberOfCards: 15, // Number of cards displayed to the player
  gameTime: 60, // Game maximum time in seconds
};
